import type { Cti } from "@amzn/aquila-service-type-script-client";

export enum ReportIssueCtiType {
    "A&IPilotInsights" = "A&IPilotInsights",
    AudienceFunnelSizing = "AudienceFunnelSizing",
    BrandLoyalty = "BrandLoyalty",
    BrandedSearchTrends = "BrandedSearchTrends",
    PathToPurchase = "PathToPurchase",
    PeerBenchmarking = "PeerBenchmarking",
    ShareOfVoice = "ShareOfVoice",
    CAIRE = "CAIRE",
    IHub = "IHub",
    InsightsDefault = "InsightsDefault",
    Titan = "Titan",
    SIP = "SIP",
}

export const DEFAULT_REPORT_ISSUE_CTI: Cti = {
    category: "Advertising",
    type: "Insights Hub",
    item: "Report Issue",
    resolverGroup: "ihub-rai-helios",
};

export const REPORT_ISSUE_RESOLVER_GROUP_MAP: {
    [key: string]: string;
} = {
    "FIELD-SDE": "ihub-rai-field",
    SIP: "ihub-rai-field",
    "A&IPilotInsights": "ihub-rai-field",
    "ads-asc": "ihub-rai-asc-team",
    InsightsDefault: "ihub-rai-asc-team",
    "Advertiser-Scorecard": "ihub-rai-field",
    PeerBenchmarking: "ihub-rai-field",
    "BGF Cradle": "ihub-rai-bgf-cradle",
    AudienceFunnelSizing: "ihub-rai-audience-funnel",
    BrandLoyalty: "ihub-rai-brand-loyalty",
    BrandedSearchTrends: "ihub-rai-field",
    PathToPurchase: "ihub-rai-path-to-purchase",
    ShareOfVoice: "ihub-rai-field",
    CAIRE: "ihub-rai-caire",
    Titan: "ihub-rai-titan",
    IHub: "ihub-rai-helios",
    "Insight-Prod-Infra-MINT": "ihub-rai-insight-prod-infra",
    "Packaged-Insights-MINT": "ihub-rai-caire",
};
